import { type PropsWithChildren } from "react";

import { cn } from "@/components/podkit/lib/cn";

type Props = PropsWithChildren<{
    disabled?: boolean;
}>;
export const InputFieldHint = ({ disabled = false, children }: Props) => {
    return (
        <span className={cn("text-sm", disabled ? "text-content-tertiary" : "text-content-secondary")}>{children}</span>
    );
};
